// @flow

import { connect } from 'react-redux';

import * as Account from 'app/entities/Account';
import ToggleTeamsUpgradeButton from 'app/viewport/components/TopBar/ToggleTeamsUpgradeButton';
import { isCurrentProfileAdminOfCurrentAccount } from 'app/account/Selectors';

import { type Dispatch } from 'app/common/types';

const mapStateToProps = state => {
  const account = Account.selectors.all.currentAccount(state);
  return {
    id: Account.selectors.id(account),
    shouldAutoUpgradeToTeams: Account.selectors.shouldAutoUpgradeToTeams(
      account
    ),
    shouldRenderButton: isCurrentProfileAdminOfCurrentAccount(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onToggleTeamsAutoUpgrade(id: number, shouldAutoUpgradeToTeams: boolean) {
    const messages = {
      error: 'Could not toggle teams auto-upgrade',
    };
    dispatch(
      Account.actions.toggleTeamsAutoUpgrade(!shouldAutoUpgradeToTeams, id)
    );
    dispatch(Account.actions.saveEntity(messages, id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ToggleTeamsUpgradeButton);
